import React, { useContext, useEffect } from "react";
import CommentForm from "../Forms/CommentForm";
import { AuthContext } from "../../auth";
import ForumComments from "./ForumComments";
import ForumMoreButton from "./ForumMoreButton";
import ForumLikeButton from "./ForumLikeButton";
import DoctorBadge from "../DoctorBadge";
import firebase from "../../firebase";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import AddCommentRoundedIcon from "@material-ui/icons/AddCommentRounded";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@material-ui/icons/ExpandLessRounded";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import Linkify from "react-linkify";
const useStyles = makeStyles((theme) => ({
  posts: {
    padding: 20,
    marginTop: 20,
    marginBottom: 20,
    marginLeft: 5,
    marginRight: 5,
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
  expand: {
    marginLeft: "auto",
    color: theme.palette.text.secondary,
  },
  postHeader: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
  },
  postContent: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
  },
}));

const ForumPost = (props) => {
  const classes = useStyles();
  const { currentUser } = useContext(AuthContext);
  const [collapseComments, setCollapseComments] = React.useState(false);
  const [showComment, setShowComment] = React.useState(false);
  const [commentCount, setCommentCount] = React.useState(0);
  const [commentState, setCommentState] = React.useState({
    id: "",
    currentButton: "",
    name: "",
    isComment: null,
  });
  let commentBox = null;

  useEffect(() => {
    const listenCommentCount = firebase
      .database()
      .ref("comments")
      .child(props.id);

    listenCommentCount.on("value", (data) => {
      if (data.numChildren() !== commentCount) {
        setCommentCount(data.numChildren());
      }
    });

    return () => {
      listenCommentCount.off();
    };
  }, []);

  const renderCommentBox = (event, buttonID, id, name, isComment) => {
    setCommentState({
      id: id,
      currentButton: buttonID,
      name: name,
      isComment: isComment,
    });
    if (showComment && event.currentTarget.id === commentState.currentButton) {
      setShowComment(false);
    } else {
      setShowComment(true);
    }
  };

  if (showComment) {
    commentBox = <CommentForm {...commentState} />;
  } else {
    commentBox = null;
  }

  return (
    <Card elevation={0} className={classes.posts}>
      <CardHeader
        className={classes.postHeader}
        action={
          props.postsUserID === (currentUser || {}).uid ? (
            <ForumMoreButton {...props} />
          ) : null
        }
        title={
          <Typography component="div">
            <Box
              letterSpacing={0.7}
              fontSize={20}
              fontWeight={600}
              color="secondary.light"
            >
              {props.postsTitle}
            </Box>
          </Typography>
        }
        subheader={
          <Typography component="div">
            <Box
              fontSize={14}
              display="inline"
              fontWeight={400}
              letterSpacing={0.4}
            >
              Asked by&nbsp;
            </Box>
            <Box
              fontSize={14}
              display="inline"
              fontWeight="fontWeightBold"
              className={classes.secondaryText}
            >
              {props.postsName}
              <DoctorBadge type="SMALL" id={props.postsUserID} />
              &nbsp;
            </Box>
            <Box
              fontSize={14}
              display="inline"
              fontWeight={460}
              className={classes.secondaryText}
            >
              ·&nbsp;{props.postsDate}
            </Box>
            {props.postsEdited ? (
              <Box
                fontSize={14}
                display="inline"
                fontWeight={400}
                letterSpacing={0.4}
              >
                &nbsp;·&nbsp;edited
              </Box>
            ) : null}
          </Typography>
        }
      />
      <CardContent className={classes.postContent}>
        <Typography component="div">
          <Box
            whiteSpace="pre-wrap"
            letterSpacing={0.1}
            fontSize={16}
            fontWeight={400}
            lineHeight={1.43}
          >
            <Linkify
              properties={{
                target: "_blank",
                style: { color: "red", fontWeight: "bold" },
              }}
            >
              {props.message}
            </Linkify>
          </Box>
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <ForumLikeButton {...props} />
        {currentUser ? (
          <Tooltip
            title="Reply"
            enterDelay={300}
            leaveDelay={200}
            enterNextDelay={300}
          >
            <Button
              id={props.id}
              startIcon={<AddCommentRoundedIcon />}
              disableElevation
              variant="text"
              color="secondary"
              onClick={(e) => renderCommentBox(e, props.id, props.id, "", true)}
            >
              Add Reply
            </Button>
          </Tooltip>
        ) : null}
        <Tooltip
          title={collapseComments ? "Hide Answers" : "Show Answers"}
          enterDelay={300}
          leaveDelay={200}
          enterNextDelay={300}
        >
          <Button
            startIcon={
              collapseComments ? (
                <ExpandLessRoundedIcon />
              ) : (
                <ExpandMoreRoundedIcon />
              )
            }
            disableElevation
            variant="text"
            color="default"
            className={classes.expand}
            onClick={() => {
              setCollapseComments((collapseComments) => !collapseComments);
            }}
          >
            {collapseComments
              ? `Hide Answers ${commentCount > 0 ? commentCount : ""}`
              : `Show Answers ${commentCount > 0 ? commentCount : ""}`}
          </Button>
        </Tooltip>
      </CardActions>
      <ForumComments
        id={props.id}
        reply={renderCommentBox}
        collapseComments={collapseComments}
        fromPost={props.fromPost}
      />
      {commentBox}
    </Card>
  );
};

export default ForumPost;
